import { PropsWithChildren } from 'react';
import { State } from '@progress/kendo-data-query';
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools';
import {
  DefaultGridSettings,
  DefaultPagerSettings
} from '../constants/grid-settings';
import MediaCardBackground from './mediacard-bg';
import { OrganisationReportItemResponse } from '../types/responses/organisation-response';

export interface CardViewDataStateChangeEvent {
  dataState: State;
}

export interface NetworkOrganisationsCardProps extends State {
  data?: OrganisationReportItemResponse[];
  onDataStateChange?: (event: CardViewDataStateChangeEvent) => void;
  total?: number;
}

export const NetworkOrganisationsCard = ({
  data,
  total = 0,
  ...props
}: PropsWithChildren<NetworkOrganisationsCardProps>) => {
  const handlePageChange = (event: PageChangeEvent) => {
    raiseDataStateChangeEvent({ skip: event.skip, take: event.take });
  };

  /**
   * Raise the Grid DataState change event. I.e. filters have changed.
   * @param moreData
   */
  const raiseDataStateChangeEvent = (moreData: State) => {
    props.onDataStateChange?.({
      dataState: { ...getDataState(), ...moreData }
    });
  };

  const getDataState = () => {
    return {
      filter: props.filter,
      sort: props.sort,
      skip: props.skip,
      take:
        props.take !== undefined ? props.take : DefaultGridSettings.pageSize,
      group: props.group
    };
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <div
        className={'row grid-card-library'}
        style={{
          flexGrow: 1,
          overflow: 'auto'
        }}>
        {data &&
          data.map((org, index) => (
            <div
              className={
                'col-sm-12 col-md-6 col-lg-6 col-xl-4 d-flex align-items-stretch'
              }
              key={index}>
              <div className={'card mt-4 p-2 flex-fill'}>
                <div className={'row'}>
                  <div className={'d-grid col-3 col-md-5 col-lg-3'}>
                    <MediaCardBackground imageUrl={org.logoUrl!} />
                  </div>
                  <div className={'col-9 col-md-7 col-lg-9'}>
                    <div className={'card-body-right p-2 d-flex flex-column'}>
                      <span className={'card-text align-middle '}>
                        Name: {org.name}
                      </span>
                      <span className={'card-text align-middle '}>
                        Territory(s): {org.territory}
                      </span>
                      <span className={'card-text align-middle'}>
                        Email: {org.email}
                      </span>
                      <span className={'card-text align-middle'}>
                        Phone: {org.phoneNumber}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className={'row mt-3'}>
        <div className={'col-md-12'}>
          <Pager
            onPageChange={handlePageChange}
            total={total}
            take={
              props.take !== undefined
                ? props.take
                : DefaultGridSettings.pageSize
            }
            skip={props.skip !== undefined ? props.skip : 0}
            {...DefaultPagerSettings}
          />
        </div>
      </div>
    </div>
  );
};
